// extracted by mini-css-extract-plugin
module.exports = {"CarouselContainer":"carousel_CarouselContainer__3HfNF","Dots":"carousel_Dots__3zfRO","Dot":"carousel_Dot__3QYpG","Active":"carousel_Active__MGgk8"};